import { render, staticRenderFns } from "./FlowRecord.vue?vue&type=template&id=de8dfbb8&scoped=true"
import script from "./FlowRecord.vue?vue&type=script&lang=js"
export * from "./FlowRecord.vue?vue&type=script&lang=js"
import style0 from "./FlowRecord.vue?vue&type=style&index=0&id=de8dfbb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8dfbb8",
  null
  
)

export default component.exports